import React, { useState } from 'react';

import { TILT_DECK_ACCESS_COPY } from '../../config/freightQuoteRules';

import css from './FreightQuoteInfo.module.css';

const FreightQuoteInfo = ({ siteRequirements }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={css.root}>
      <button
        type="button"
        className={css.trigger}
        aria-expanded={isOpen}
        onClick={() => setIsOpen(!isOpen)}
      >
        Tilt-deck delivery requirements
      </button>
      {isOpen ? <p className={css.copy}>{TILT_DECK_ACCESS_COPY}</p> : null}
      {isOpen && siteRequirements ? (
        <p className={css.copy}>Seller&apos;s site requirements: {siteRequirements}</p>
      ) : null}
    </div>
  );
};

export default FreightQuoteInfo;
